import {
	ImageBrowseListingDemo1,
	ImageBrowseListingDemo2,
	ImageBrowseListingDemo3,
	ImageBrowseListingDemo4,
} from "../../assets/BrowseListing/demo";
import type { CartComparisonProperty } from "../../interfaces/comparisonProperty";

export const cartComparisonProperty: CartComparisonProperty[] = [
	{
		listingId: "101740668513",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		displayImageUrl: ImageBrowseListingDemo1,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Townhouse",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2+1",
		bathrooms: 1.5,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 2,
		dom: 21,
		openHouseDate: "2023-09-15",
		mlsNumber: "C1558446",
		squareFootage: "3420",
		lotSquareFootage: "3420",
	},
	{
		listingId: "101740678756",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		displayImageUrl: ImageBrowseListingDemo2,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Townhouse",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2+1",
		bathrooms: 1.5,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "Yes - Unfinished",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 2,
		dom: 21,
		openHouseDate: "2023-09-15",
		mlsNumber: "C5558446",
		squareFootage: "3420",
		lotSquareFootage: "3420",
	},
	{
		listingId: "1002E10428917",
		address: {
			address1: "123 Main St",
			address2: "123 Main St",
			city: "New York",
			state: "New York",
			postalCode: "32423423",
			country: "york",
		},
		displayImageUrl: ImageBrowseListingDemo3,
		totalZownSavings: 5000,
		downPaymentNeeded: 50000,
		downPaymentGiven: 23500,
		rateBuydownSavings: 1000,
		propertyType: "Apartment",
		listPrice: 450000,
		propertyTax: 5000,
		maintenanceFee: 318,
		bedrooms: "2",
		bathrooms: 1,
		squareFeet: "2340",
		squareFeetLot: "2340",
		basement: "No",
		numberOfParkingSpaces: "1",
		backyard: "Yes",
		pricePerSqft: "693",
		listToSoldRatio: 1,
		dom: 10,
		openHouseDate: "2023-09-15",
		mlsNumber: "C1558416",
		squareFootage: "3420",
		lotSquareFootage: "3420",
	},
	// {
	// 	listingId: "4",
	// 	address: {
	// 		address1: "123 Main St",
	// 		address2: "123 Main St",
	// 		city: "New York",
	// 		state: "New York",
	// 		postalCode: "32423423",
	// 		country: "york",
	// 	},
	// 	displayImageUrl: ImageBrowseListingDemo4,
	// 	totalZownSavings: 5200,
	// 	downPaymentNeeded: 50000,
	// 	downPaymentGiven: 23500,
	// 	rateBuydownSavings: 1000,
	// 	propertyType: "Apartment",
	// 	listPrice: 840000,
	// 	propertyTax: 2000,
	// 	maintenanceFee: 318,
	// 	bedrooms: "2",
	// 	bathrooms: 1,
	// 	squareFeet: "2340",
	// 	squareFeetLot: "2340",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "No",
	// 	pricePerSqft: "693",
	// 	listToSoldRatio: 1,
	// 	dom: 10,
	// 	openHouseDate: "2023-09-10",
	// 	mlsNumber: "C1558300",
	// 	squareFootage: "3420",
	// 	lotSquareFootage: "3420",
	// },
	// {
	// 	listingId: "5",
	// 	address: {
	// 		address1: "123 Main St",
	// 		address2: "123 Main St",
	// 		city: "New York",
	// 		state: "New York",
	// 		postalCode: "32423423",
	// 		country: "york",
	// 	},
	// 	displayImageUrl: ImageBrowseListingDemo3,
	// 	totalZownSavings: 5200,
	// 	downPaymentNeeded: 50000,
	// 	downPaymentGiven: 23500,
	// 	rateBuydownSavings: 1000,
	// 	propertyType: "Apartment",
	// 	listPrice: 840000,
	// 	propertyTax: 2000,
	// 	maintenanceFee: 318,
	// 	bedrooms: "2",
	// 	bathrooms: 1,
	// 	squareFeet: "2340",
	// 	squareFeetLot: "2340",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "No",
	// 	pricePerSqft: "693",
	// 	listToSoldRatio: 1,
	// 	dom: 10,
	// 	openHouseDate: "2023-09-10",
	// 	mlsNumber: "C1558300",
	// 	squareFootage: "3420",
	// 	lotSquareFootage: "3420",
	// },
	// {
	// 	listingId: "6",
	// 	address: {
	// 		address1: "123 Main St",
	// 		address2: "123 Main St",
	// 		city: "New York",
	// 		state: "New York",
	// 		postalCode: "32423423",
	// 		country: "york",
	// 	},
	// 	displayImageUrl: ImageBrowseListingDemo2,
	// 	totalZownSavings: 5200,
	// 	downPaymentNeeded: 50000,
	// 	downPaymentGiven: 23500,
	// 	rateBuydownSavings: 1000,
	// 	propertyType: "Apartment",
	// 	listPrice: 840000,
	// 	propertyTax: 2000,
	// 	maintenanceFee: 318,
	// 	bedrooms: "2",
	// 	bathrooms: 1,
	// 	squareFeet: "2340",
	// 	squareFeetLot: "2340",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "No",
	// 	pricePerSqft: "693",
	// 	listToSoldRatio: 1,
	// 	dom: 10,
	// 	openHouseDate: "2023-09-10",
	// 	mlsNumber: "C1558300",
	// 	squareFootage: "3420",
	// 	lotSquareFootage: "3420",
	// },
	// {
	// 	listingId: "7",
	// 	address: {
	// 		address1: "123 Main St",
	// 		address2: "123 Main St",
	// 		city: "New York",
	// 		state: "New York",
	// 		postalCode: "32423423",
	// 		country: "york",
	// 	},
	// 	displayImageUrl: ImageBrowseListingDemo1,
	// 	totalZownSavings: 5200,
	// 	downPaymentNeeded: 50000,
	// 	downPaymentGiven: 23500,
	// 	rateBuydownSavings: 1000,
	// 	propertyType: "Apartment",
	// 	listPrice: 840000,
	// 	propertyTax: 2000,
	// 	maintenanceFee: 318,
	// 	bedrooms: "2",
	// 	bathrooms: 1,
	// 	squareFeet: "2340",
	// 	squareFeetLot: "2340",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "No",
	// 	pricePerSqft: "693",
	// 	listToSoldRatio: 1,
	// 	dom: 10,
	// 	openHouseDate: "2023-09-10",
	// 	mlsNumber: "C1558300",
	// 	squareFootage: "3420",
	// 	lotSquareFootage: "3420",
	// },
	// {
	// 	listingId: "8",
	// 	address: {
	// 		address1: "456 Elm St",
	// 		address2: "456 Elm St",
	// 		city: "Brooklyn",
	// 		state: "New York",
	// 		postalCode: "11201",
	// 		country: "USA",
	// 	},
	// 	displayImageUrl: "ImageBrowseListingDemo5",
	// 	totalZownSavings: 4500,
	// 	downPaymentNeeded: 60000,
	// 	downPaymentGiven: 30000,
	// 	rateBuydownSavings: 1500,
	// 	propertyType: "Condo",
	// 	listPrice: 500000,
	// 	propertyTax: 4500,
	// 	maintenanceFee: 280,
	// 	bedrooms: "1",
	// 	bathrooms: 1,
	// 	squareFeet: "1200",
	// 	squareFeetLot: "1200",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "0",
	// 	backyard: "No",
	// 	pricePerSqft: "417",
	// 	listToSoldRatio: 1.2,
	// 	dom: 15,
	// 	openHouseDate: "2023-09-20",
	// 	mlsNumber: "B112300",
	// 	squareFootage: "1200",
	// 	lotSquareFootage: "1200",
	// },
	// {
	// 	listingId: "9",
	// 	address: {
	// 		address1: "789 Oak St",
	// 		address2: "789 Oak St",
	// 		city: "Queens",
	// 		state: "New York",
	// 		postalCode: "11375",
	// 		country: "USA",
	// 	},
	// 	displayImageUrl: "ImageBrowseListingDemo6",
	// 	totalZownSavings: 3000,
	// 	downPaymentNeeded: 40000,
	// 	downPaymentGiven: 20000,
	// 	rateBuydownSavings: 1200,
	// 	propertyType: "Single Family Home",
	// 	listPrice: 380000,
	// 	propertyTax: 3500,
	// 	maintenanceFee: 0,
	// 	bedrooms: "3",
	// 	bathrooms: 2,
	// 	squareFeet: "2000",
	// 	squareFeetLot: "4000",
	// 	basement: "Yes - Finished",
	// 	numberOfParkingSpaces: "2",
	// 	backyard: "Yes",
	// 	pricePerSqft: "190",
	// 	listToSoldRatio: 1.1,
	// 	dom: 30,
	// 	openHouseDate: "2023-09-18",
	// 	mlsNumber: "Q345679",
	// 	squareFootage: "2000",
	// 	lotSquareFootage: "4000",
	// },
	// {
	// 	listingId: "10",
	// 	address: {
	// 		address1: "321 Pine St",
	// 		address2: "321 Pine St",
	// 		city: "Manhattan",
	// 		state: "New York",
	// 		postalCode: "10001",
	// 		country: "USA",
	// 	},
	// 	displayImageUrl: "ImageBrowseListingDemo7",
	// 	totalZownSavings: 6000,
	// 	downPaymentNeeded: 70000,
	// 	downPaymentGiven: 35000,
	// 	rateBuydownSavings: 2000,
	// 	propertyType: "Penthouse",
	// 	listPrice: 1200000,
	// 	propertyTax: 8000,
	// 	maintenanceFee: 400,
	// 	bedrooms: "3",
	// 	bathrooms: 2.5,
	// 	squareFeet: "3000",
	// 	squareFeetLot: "3000",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "No",
	// 	pricePerSqft: "400",
	// 	listToSoldRatio: 1.5,
	// 	dom: 25,
	// 	openHouseDate: "2023-09-25",
	// 	mlsNumber: "M100500",
	// 	squareFootage: "3000",
	// 	lotSquareFootage: "3000",
	// },
	// {
	// 	listingId: "11",
	// 	address: {
	// 		address1: "159 Maple Ave",
	// 		address2: "159 Maple Ave",
	// 		city: "Bronx",
	// 		state: "New York",
	// 		postalCode: "10451",
	// 		country: "USA",
	// 	},
	// 	displayImageUrl: "ImageBrowseListingDemo8",
	// 	totalZownSavings: 4000,
	// 	downPaymentNeeded: 45000,
	// 	downPaymentGiven: 22500,
	// 	rateBuydownSavings: 1100,
	// 	propertyType: "Co-op",
	// 	listPrice: 300000,
	// 	propertyTax: 1500,
	// 	maintenanceFee: 250,
	// 	bedrooms: "2",
	// 	bathrooms: 1.5,
	// 	squareFeet: "1500",
	// 	squareFeetLot: "1500",
	// 	basement: "No",
	// 	numberOfParkingSpaces: "1",
	// 	backyard: "Yes",
	// 	pricePerSqft: "200",
	// 	listToSoldRatio: 1.2,
	// 	dom: 20,
	// 	openHouseDate: "2023-09-22",
	// 	mlsNumber: "B104151",
	// 	squareFootage: "1500",
	// 	lotSquareFootage: "1500",
	// },
	// {
	// 	listingId: "12",
	// 	address: {
	// 		address1: "987 Birch Blvd",
	// 		address2: "987 Birch Blvd",
	// 		city: "Staten Island",
	// 		state: "New York",
	// 		postalCode: "10301",
	// 		country: "USA",
	// 	},
	// 	displayImageUrl: "ImageBrowseListingDemo9",
	// 	totalZownSavings: 5000,
	// 	downPaymentNeeded: 55000,
	// 	downPaymentGiven: 27500,
	// 	rateBuydownSavings: 1300,
	// 	propertyType: "Duplex",
	// 	listPrice: 450000,
	// 	propertyTax: 3000,
	// 	maintenanceFee: 200,
	// 	bedrooms: "4",
	// 	bathrooms: 3,
	// 	squareFeet: "2500",
	// 	squareFeetLot: "5000",
	// 	basement: "Yes - Partially Finished",
	// 	numberOfParkingSpaces: "3",
	// 	backyard: "Yes",
	// 	pricePerSqft: "180",
	// 	listToSoldRatio: 1.3,
	// 	dom: 40,
	// 	openHouseDate: "2023-09-30",
	// 	mlsNumber: "S103450",
	// 	squareFootage: "2500",
	// 	lotSquareFootage: "5000",
	// },
];

export const fieldTitles: { [key: string]: string } = {
	// "address.city": "City",
	// transitDistance: "Distance to Transit",
	// walkScore: "Walk Score",
	// bikeScore: "Bike Score",
	// busScore: "Bus Score",
	downPaymentBoost: "Down Payment Boost",
	propertyType: "Property Type",
	mlsId: "Property Type",
	mlsNumber: "MLS ID",
	listPrice: "Price",
	tax: "Property Tax",
	maintenanceFee: "Maintenance Fee",
	numBedrooms: "Bedrooms",
	numBathrooms: "Bathrooms",
	sqft: "Square Footage",
	lot: "Lot Square Footage",
	basement: "Basement",
	backyard: "Backyard",
	pricePerSqft: "Price per SQFT",
	daysOnMarket: "Days on Market",
	openHouseDate: "Open House Date",
	listToSoldRatio: "List to Sold Ratio",
	parking: "Parking",
};

export const sections = [
	// {
	// 	title: "Location",
	// 	fields: [
	// 		"address.city",
	// 		//  "transitDistance",
	// 		//   "walkScore",
	// 		//    "bikeScore",
	// 		//     "busScore"
	// 	],
	// },
	{
		title: "Details",
		fields: [
			"downPaymentBoost",
			"propertyType",
			"mlsNumber",
			"listPrice",
			"tax",
			"maintenanceFee",
		],
	},
	{
		title: "Features",
		fields: ["numBedrooms", "numBathrooms", "sqft", "lot", "basement"],
	},
	{
		title: "More Details",
		fields: [
			"parking",
			"backyard",
			"pricePerSqft",
			"listToSoldRatio",
			"daysOnMarket",
			"openHouseDate",
		],
	},
];
